import { APIService } from '@laxmimanogna/code-quick-components';
import { ACCESS_TOKEN } from '../constants/PreferenceKeys';

export const API = new APIService({ accessTokenPreferenceKey: ACCESS_TOKEN })